/**
 * Query key for the signed-in user.
 *
 * @since 1.3.0
 */
export const SESSION_QUERY_KEY = ['session'] as const;

/**
 * Query key for the overview payload, shared by the shell and the overview page.
 *
 * @since 1.3.0
 */
export const OVERVIEW_QUERY_KEY = ['overview'] as const;

/**
 * Root of every alert list query key.
 *
 * @since 1.3.0
 */
export const ALERTS_QUERY_KEY = 'alerts';

/**
 * Query key for the mute rule list.
 *
 * @since 1.3.0
 */
export const MUTE_RULES_QUERY_KEY = ['mute-rules'] as const;

/**
 * Root of every mail event list query key.
 *
 * @since 1.3.0
 */
export const MAIL_EVENTS_QUERY_KEY = 'mail-events';

/**
 * Root of every form list query key.
 *
 * @since 1.3.0
 */
export const FORMS_QUERY_KEY = 'forms';

/**
 * Query key for the client roster.
 *
 * @since 1.3.0
 */
export const CLIENTS_QUERY_KEY = ['clients'] as const;

/**
 * Root of every picker query key. Every picker shares a root so one invalidation can refresh
 * them all when the thing they offer changes.
 *
 * @since 1.4.0
 */
export const OPTIONS_QUERY_KEY = 'options';

/**
 * Root of every single-client query key.
 *
 * @since 1.3.0
 */
export const CLIENT_QUERY_KEY = 'client';

/**
 * Root of every client onboarding query key.
 *
 * @since 1.3.0
 */
export const CLIENT_ONBOARDING_QUERY_KEY = 'client-onboarding';

/**
 * Root of every check-run query key.
 *
 * @since 1.3.0
 */
export const CHECK_RUNS_QUERY_KEY = 'check-runs';

/**
 * Query key for the check registry.
 *
 * @since 1.3.0
 */
export const CHECKS_QUERY_KEY = ['checks'] as const;

/**
 * Query key for the provider account list.
 *
 * @since 1.3.0
 */
export const PROVIDER_ACCOUNTS_QUERY_KEY = ['provider-accounts'] as const;

/**
 * Query key for the user list.
 *
 * @since 1.3.0
 */
export const USERS_QUERY_KEY = ['users'] as const;

/**
 * Query key for external connection health.
 *
 * @since 1.3.0
 */
export const CONNECTIONS_QUERY_KEY = ['settings', 'connections'] as const;

/**
 * Query key for the alert routing table.
 *
 * @since 1.3.0
 */
export const ALERTING_QUERY_KEY = ['settings', 'alerting'] as const;

/**
 * Query key for the canary mailbox confirmation.
 *
 * @since 1.3.0
 */
export const QC_MAILBOX_QUERY_KEY = ['settings', 'qc-mailbox'] as const;
